import { Table } from "@chakra-ui/react";
import { memo } from "react";
import { formatCalendarDate } from "../../contracts/columns";
import { formatDocument } from "../../screenings/columns";
import { propertyUseLabels } from "../../screenings/mappers/screening.mapper";
import { formatCop } from "../format";
import type { PreApprovedScreening } from "../types";

type Props = {
  screening: PreApprovedScreening;
  selected: boolean;
};

// Read-only: the slider decides which rows are in, and a highlighted row is
// one that is. Memoized on primitives, so moving the slider only re-renders
// the rows that change side.
const SelectionRow = memo(({ screening, selected }: Props) => (
  <Table.Row bg={selected ? "palomma.50" : undefined}>
    <Table.Cell>{formatDocument(screening)}</Table.Cell>
    <Table.Cell>{screening.tenantName}</Table.Cell>
    <Table.Cell>{screening.propertyAddress ?? "—"}</Table.Cell>
    <Table.Cell>{formatCop(screening.monthlyRent)}</Table.Cell>
    <Table.Cell>
      {screening.contractEndDate
        ? formatCalendarDate(screening.contractEndDate)
        : "—"}
    </Table.Cell>
    <Table.Cell>
      {screening.rentBillingDay ? `día ${screening.rentBillingDay}` : "—"}
    </Table.Cell>
    <Table.Cell>{screening.rentGuaranteeProvider ?? "—"}</Table.Cell>
    <Table.Cell>
      {screening.propertyUse ? propertyUseLabels[screening.propertyUse] : "—"}
    </Table.Cell>
    <Table.Cell>{screening.cosignerCount ?? "—"}</Table.Cell>
  </Table.Row>
));
SelectionRow.displayName = "SelectionRow";

export default SelectionRow;
